import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-role-management-detail',
  templateUrl: './role-management-detail.component.html',
  styleUrls: ['./role-management-detail.component.scss'],
})
export class RoleManagementDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
